import React from 'react';
import PropTypes from 'prop-types';

import styles from './allowanceNote.module.css';

const AllowanceNote = ({ type, service }) => (
  <div className={styles.container}>
    {(() => {
      if (type === 8) {
        return 'This practice only allows returning patients to book appointments online.';
      }
      if (type === 2 || type === 4) {
        return `This practice only allows enrolled ${
          type === 2 ? 'and funded' : ''
        } patients to
             ${
               service === 1
                 ? 'book appointments'
                 : 'request repeat prescriptions'
             } online.`;
      }
      return '';
    })()}
  </div>
);

AllowanceNote.propTypes = {
  type: PropTypes.number,
  service: PropTypes.number,
};

export default AllowanceNote;
